export class IContactCompany {
    companyRevisionId: string;
    companyName: string;
    companyVersion: string;
    companyContactRoleCode: string;
    companyContactRoleDescription: string;
    contactRevisionId: string;
    contactName: string;
    contactType: string;
    associationActiveFlag: boolean;
    associationType: string;
}

